export default __webpack_public_path__ + "static/media/StanleyHudson.bb519ceb.jpg";